import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const StoreContext = createContext(null);

export function StoreProvider({ children }) {
  const [stores, setStores] = useState([]);
  const [activeStore, setActiveStore] = useState("all"); // "all" or store id

  useEffect(() => {
    api.get("/masters/stores").then((res) => setStores(res.data)).catch(() => {});
  }, []);

  return (
    <StoreContext.Provider value={{ stores, activeStore, setActiveStore }}>
      {children}
    </StoreContext.Provider>
  );
}

export const useStores = () => useContext(StoreContext);
